import React from 'react'
import {
  Row,
  Title,
  TitleLink,
  Content,
} from './styles'

export default function ContentBlock({
  title,
  content,
  thinTitle,
  linkTitle,
  children,
}) {
  return (
    <Row>
      <Title thin={thinTitle}>
        {
          linkTitle
            ? <TitleLink href={linkTitle}>{title}</TitleLink>
            : title
        }
      </Title>
      <Content>{children}</Content>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/common/ContentBlock/index.js